import React from 'react'
import { Breadcrumb, BreadcrumbItem, Button, Table, Container, Row, Col, Label, Input } from 'reactstrap'
import '../css/QuoteViewController.css'
import { AlertModalModel } from './modal/AlertModalController'
import { Quote } from '../model/Quote'
import { SearchModel } from '../model/SearchModel'
import { getQuote, getQuotes, deleteQuote, createQuote } from '../model/request/quotes'
import { ObjectToParams } from '../model/request/urlparser'
import { frontEndBaseURL } from '../model/request/url'
import DateTextField from '../view/DateTextField'
import { formatAsDollarValue, moneyText } from '../model/Formatting'
import { LocalSettings } from '../model/LocalSettings'

class QuotesViewController extends React.Component {

    constructor(props) {
        super(props)
        if (props.quotes) {
            this.state = {
                search: SearchModel.from(props.params),
                quotes: props.quotes,
            }
        } else {
            this.state = {
                search: SearchModel.from(props.params),
                quotes: null,
            }
        }
    }

    componentDidMount() {
        this.searchQuotes()
    }


    searchQuotes(search) {
        if (!search) {
            search = this.state.search
        }

        this.props.turnOnLoader()
        getQuotes(search)
        .then(
            (result) => {
                const newQuotes = []
                for (let i = 0; i < result.data.quotes.length; i++) {
                    newQuotes.push(Quote.from(result.data.quotes[i]))
                }

                this.setState({
                    quotes: newQuotes
                })
                this.props.turnOffLoader()
            },
            (error) => {
                this.props.showError(error)
                this.props.turnOffLoader()
            }
        )
    }

    updateSearchState(params, value, shouldSearchQuotes=false) {
        if (!Array.isArray(params)) {
            params = [params]
        }

        const search = this.state.search.copy()

        const param = params[0]
        if (param === 'order_by') {
            if (search[param] === value) {
                search.reverse_order = !search.reverse_order
            } else {
                search.reverse_order = false
            }
            search.order_by = value
            this.searchQuotes(search)
            //this.searchButtonClicked(search)
        }

        let sparam = search
        for (let i = 0; i < params.length-1; i++) {
            sparam = sparam[params[i]]
        }

        sparam[params[params.length - 1]] = value

        const settings = LocalSettings.fromStorage()
        settings.update('page_count', search.page_count)

        if (shouldSearchQuotes) {
            this.searchQuotes(search)
        }

        this.setState({
            'search': search
        })
    }

    onKeyDownOnSignTextField(e) {
        if (e.keyCode === 13) {
            this.searchButtonClicked()
        }
    }

    copyQuote(e, index) {
        // e.stopPropagation();
        // e.nativeEvent.stopImmediatePropagation()

        const quote = this.state.quotes[index]
        this.props.turnOnLoader()
        getQuote(quote.id).then(
            (result) => {
                const resultQuote = Quote.from(result.data.quote)
                resultQuote.job_name += ' Duplicate'
                this.appendQuote(resultQuote, index)
                this.props.turnOffLoader()
            },
            (error) => {
                this.props.showError(error)
                this.props.turnOffLoader()
            }
        )
    }

    deleteQuote(e, index) {
        // e.stopPropagation();
        // e.nativeEvent.stopImmediatePropagation()

        const name = this.state.quotes[index].job_name
        this.props.showAlertModal(
            (new AlertModalModel())
                .setTitle('Warning')
                .setMessage('Are you sure you want to delete ' + name + '. ' +
                    'This action can not be undone.')
                .addYesButton((e) => {
                    const id = this.state.quotes[index].id

                    this.props.turnOnLoader()
                    deleteQuote(id).then(
                        (result) => {
                            this.props.turnOffLoader()
                            const quotes = this.state.quotes
                            quotes.splice(index, 1)

                            this.setState(function(state, props) {
                                return {
                                    quotes: quotes
                                }
                            })
                        },
                        (error) => {
                            this.props.showError(error)
                            this.props.turnOffLoader()
                        }
                    )

                    this.props.closeModal()
                })
                .addCancelButton((e) => {this.props.closeModal()})
        )
    }

    appendQuote(quote, index=null) {

        if (!quote) {
            quote = new Quote()
        }
        quote = Quote.from(quote)

        this.props.turnOnLoader()
        createQuote(quote).then(
            (result) => {
                const quote = Quote.from(result.data.quote)
                let quotes = this.state.quotes
                if (typeof index === 'number') {
                    const begining = quotes.slice(0, index+1)
                    begining.push(quote)
                    quotes = begining.concat(quotes.slice(index+1))
                } else {
                    quotes.push(quote)
                }
                this.setState(function(state, props) {
                    return {
                        'quotes': quotes
                    }
                })
                this.props.turnOffLoader()
            },
            (error) => {
                this.props.showError(error)
                this.props.turnOffLoader()
            }
        )
    }

    searchButtonClicked(search) {
        if (!search) {
            search = this.state.search
        }
        window.location.href = frontEndBaseURL + '/quotes' + ObjectToParams(search)
    }


    // MARK: View

    makeRows() {
        if (this.state.quotes) {
            return this.state.quotes.map((quote, index) =>
                <tr key={"row"+index}>
                    <td className="text-right"><Label>{quote.given_id}</Label></td>
                    <td className="text-right"><Label><a href={'/quote/' + quote.id} text={quote.job_name || 'Blank'}>{quote.job_name || 'Blank'}</a></Label></td>
                    <td className="text-right"><Label>
                        <a href={'/customerreport?filter=All&company=' + quote.customer_name}>
                            {quote.customer_name}
                        </a>
                    </Label></td>
                    <td className="text-right"><Label>{quote.formatQuoteDate()}</Label></td>
                    <td className="text-right"><Label><span text={moneyText(quote.total_price)}>{formatAsDollarValue(quote.total_price)}</span></Label></td>
                    <td className="text-right"><Button
                        className='btn btn-copy'
                            onClick={(e) => this.copyQuote(e, index)}
                            >Copy</Button></td>
                    <td className="text-right"><Button color="danger" onClick={(e) => this.deleteQuote(e, index)} >Delete</Button></td>
                </tr>
            )
        }
        return <></>
    }

    createSearchField(varnames, label, isDate=false) {
        if (!Array.isArray(varnames)) {
            varnames = [varnames]
        }

        let variable = this.state.search
        for (let i = 0; i < varnames.length; i++) {
            variable = variable[varnames[i]]
        }

        return <Col>
            <div className="header-label">
                <Label className="label-weight">{label}</Label>
                {
                    isDate ?
                    <DateTextField
                        onChange={(date) => this.updateSearchState(varnames, date)}
                        value={variable}
                        showModal={this.props.showModal}
                        closeModal={this.props.closeModal}
                        onKeyDown={(e) => this.onKeyDownOnSignTextField(e)} />
                    : <Input
                        onChange={(e) => this.updateSearchState(varnames, e.target.value)}
                        value={variable}
                        onKeyDown={(e) => this.onKeyDownOnSignTextField(e)} />
                }
            </div>
         </Col>
    }

    makeTableHeaders(varname, label) {

        let name = "fa fa-fw fa-sort"
        if (this.state.search.order_by === varname) {
            name += this.state.search.reverse_order ?
                '-up' : '-down'
        }

        return <th className="text-right label-weight"
            style={{'minWidth': '200px'}}
            onClick={(e) => this.updateSearchState('order_by', varname)}>{label}<i className={name}></i></th>
    }

    render() {
        return (
            <Container style={{'paddingTop': '50px'}}>
                <Row>
                    <Col>
                        <Breadcrumb tag="nav" listTag="div">
                            <BreadcrumbItem active tag="span">Jobs</BreadcrumbItem>
                            <BreadcrumbItem tag="a" href="/">New Quote</BreadcrumbItem>
                        </Breadcrumb>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Label style={{
                            'fontSize': '18pt',
                            'fontWeight': '500',
                        }}>Search</Label>
                    </Col>
                </Row>
                <Row xs="1" sm="3">
                    {this.createSearchField('given_id', 'Quote Number')}
                    {this.createSearchField('customer_name', 'Customer Name')}
                    {this.createSearchField('job_name', 'Job Name')}
                    {this.createSearchField(['quote_date', 'min'], 'Min Date', true)}
                    {this.createSearchField(['quote_date', 'max'], 'Max Date', true)}
                    {this.createSearchField('given_id_search_terms', 'Sign Type')}
                </Row>
                <Row>
                    <Col style={{'textAlign': 'right'}}>
                        <Container style={{'padding': '10px'}}>
                            <Button color="primary" onClick={(e) => this.searchButtonClicked()}>Search</Button>
                        </Container>
                    </Col>
                </Row>
                <Row><Col><Container style={{'overflowX': 'auto'}}><Table>
                    <thead>
                        <tr>
                            {this.makeTableHeaders('given_id', 'Quote Id')}
                            {this.makeTableHeaders('job_name', 'Job Name')}
                            {this.makeTableHeaders('customer_name', 'Customer Name')}
                            {this.makeTableHeaders('quote_date', 'Date')}
                            {this.makeTableHeaders('total_price', 'Total Price')}
                        </tr>
                    </thead>
                    <tbody>
                        {this.makeRows()}
                    </tbody>
                </Table></Container></Col></Row>
                <Row>
                    <Col>
                        <Container style={{'paddingRight': '24px', 'textAlign': 'right'}}>
                            <Button disabled={!this.state.quotes} color="success" onClick={(e) => this.appendQuote(Quote.from({'job_name': 'new'}))}>Add</Button>
                        </Container>
                    </Col>
                </Row>
                <Row xs="2" sm="3" style={{'marginBottom': '20px'}}>
                    <Col>
                        <Label>Page</Label>
                        <Input
                            value={this.state.search.page}
                            onChange={(e) => this.updateSearchState('page', e.target.value)} />

                        <a href='#page'
                            onClick={(e) => {
                                this.updateSearchState('page',
                                    parseInt(this.state.search.page-1), true)
                            }} >Previous</a>
                        <a href='#page'
                            style={{'float': 'right'}}
                            onClick={(e) => {
                                this.updateSearchState('page',
                                    parseInt(this.state.search.page)+1, true)
                            }} >Next</a>
                    </Col>
                    <Col>
                        <Label>Items Per Page</Label>
                        <Input
                            value={this.state.search.page_count}
                            onChange={(e) => this.updateSearchState('page_count', e.target.value)} />
                    </Col>
                    <Col>
                        <Button
                            color="primary"
                            style={{'marginTop': '30px', 'float': 'right'}}
                            onClick={(e) => this.searchButtonClicked()}>Search</Button>
                    </Col>
                </Row>
            </Container>
        )
    }
}

export default QuotesViewController;
